export default "__VITE_ASSET__5oj0fhu1__"